<template>
  <div class="repairPage-container repairReq-container">
    <div class="repairReq-header">
      <div class="repairReq-header-win">
        <p class="repairReq-header-title multiple-family font-format-normal">
          寄修地址：
        </p>

        <p>
          <span class="multiple-family font-format-medium">联系人：</span>
          <span class="font-format-medium medium-family">文石售后维修</span>
        </p>
        <!-- <p class="repairReq-header-line">|</p> -->
        <p>
          <span class="multiple-family font-format-medium">电话：</span>
          <span class="font-format-medium medium-family">13826127601</span>
        </p>
        <!-- <p class="repairReq-header-line">|</p> -->
        <p>
          <span class="multiple-family font-format-medium">地址：</span>
          <span class="font-format-medium medium-family"
            >广州市南沙区东涌镇市鱼路202号一楼（4号楼）</span
          >
        </p>
        <el-button
          class="repairReq-header-copy"
          type="primary"
          size="mini"
          @click="copyAddress"
          >复制</el-button
        >
      </div>
      <div class="repairReq-header-mobile">
        <el-popover placement="top" width="200" trigger="click">
          <div>
            <p class="font-format-medium2">联系人：文石售后维修</p>
            <p class="font-format-medium2">电话：13826127601</p>
            <p class="font-format-medium2">
              地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）
            </p>
          </div>
          <div style="text-align: right; margin: 0">
            <el-button type="primary" size="mini" @click="copyAddress"
              >复制</el-button
            >
          </div>
          <el-button slot="reference" size="mini" type="primary"
            >寄修地址</el-button
          >
        </el-popover>
      </div>
    </div>

    <div class="repairReq-main">
      <div class="repairReq-steps">
        <p class="repairReq-steps-title font-format-plus">提交寄修信息</p>
        <el-steps class="repairReq-pc-steps" :active="active" align-center>
          <el-step title="选择寄修设备" />
          <el-step title="填写故障信息" />
          <el-step title="登记寄回部件" />
          <!-- <el-step title="确认物流地址" /> -->
          <el-step title="提交" />
        </el-steps>
      </div>
      <Step1
        v-if="active === 1"
        :device="params.details[0]"
        @nextPage="nextPage"
      />
      <Step2
        v-if="active === 2"
        :device="params.details[0]"
        :params="params"
        @goBack="goBack"
        @nextPage="nextPage"
      />
      <Step3
        v-if="active === 3"
        :device="params.details[0]"
        :params="params"
        @goBack="goBack"
        @nextPage="nextPage"
        @saveData="saveData"
      />
      <!-- <AbroadStep3
        v-if="active === 3 && !isInLand"
        :device="params.details[0]"
        :params="params"
        @goBack="goBack"
        @nextPage="nextPage"
        @saveData="saveData"
      /> -->
      <!-- <Step4 v-if="active === 4" @goBack="goBack" @nextPage="nextPage" /> -->
      <Step5
        v-if="active === 4"
        @goBack="goBack"
        @nextPage="nextPage"
        :repairData="params"
        @saveData="saveData"
      />
    </div>
    <el-dialog
      :title="tipsTitle"
      :visible.sync="showTips"
      width="310px"
      @close="closeTips"
    >
      <div v-html="tipsMsg"></div>
      <div slot="footer" class="dialog-footer">
        <el-button v-show="false" @click="showTips = false">{{
          $t("common.cancel")
        }}</el-button>
        <el-button type="primary" @click="showTips = false">我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Step1 from "./components/step1";
import Step2 from "./components/step2";
import Step3 from "./components/step3";
import AbroadStep3 from "./components/abroad/step3";
import Step4 from "./components/step4";
import Step5 from "./components/step5";
import { isMobileDevice } from "@/utils";

export default {
  computed: {
    isInLand() {
      return process.env.VUE_APP_AREA === "inland";
    },
  },
  components: { Step1, Step2, Step3, AbroadStep3, Step4, Step5 },
  data() {
    return {
      active: 1,
      params: {
        attachs: [],
        tmpAddress: "",
        sendAddress: "",
        sendContact: "",
        receiveDeliveryInc: "",
        receiveDeliveryCode: "",
        sendPhone: "",
        phone: "",
        customer: "",
        email: "",
        zipCode: "",
        country: "",
        areaCode: {},
        area: [],
        details: [
          {
            model: "",
            desc: "",
            sn: "",
            purTime: "",
            powerOnPass: "",
            fittings: [],
            fittingsData: [],
            purchases: [],
          },
        ],
      },
      showTips: false,
      tipsTitle: "",
      tipsMsg: "",
      isMobile: isMobileDevice(),
    };
  },
  inject: ["scrollTo"],
  methods: {
    async getDetails() {
      let res = await this.$http.getRepairReqDetails({
        id: this.$route.query.id,
      });
      this.params.id = res.data.id;
      this.params.attachs = res.data.attachs || [];
      this.params.sendAddress = res.data.sendAddress;
      this.params.tmpAddress = res.data.tmpAddress;
      this.params.sendContact = res.data.sendContact;
      this.params.receiveDeliveryInc = res.data.receiveDeliveryInc;
      this.params.receiveDeliveryCode = res.data.receiveDeliveryCode;
      this.params.sendPhone = res.data.sendPhone;
      this.params.phone = res.data.phone;
      this.params.customer = res.data.customer;
      this.params.areaCode = res.data.areaCode;
      this.params.country = res.data.country || "";
      this.params.email = res.data.email || "";
      this.params.zipCode = res.data.zipCode || "";
      this.params.area = res.data.area.split("/");
      this.params.details[0].model = res.data.details[0].model;
      this.params.details[0].purchases = res.data.details[0].purchases || [];
      this.params.details[0].desc = res.data.details[0].desc;
      this.params.details[0].sn = res.data.details[0].sn;
      this.params.details[0].purTime = res.data.details[0].purTime;
      this.params.details[0].powerOnPass = res.data.details[0].powerOnPass;
      this.params.details[0].fittings = res.data.details[0].fittings || [];
    },
    goBack(step = null) {
      if (step) {
        this.active = step;
      } else {
        if (this.active !== 1) {
          this.active -= 1;
        }
      }
      this.scrollTo(0);
    },
    nextPage() {
      this.active += 1;
      this.scrollTo(0);
    },

    async saveData(status) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
      try {
        delete this.params.details[0].fittingsData;
        for (let item of this.params.attachs) {
          if (item && item.url) {
            delete item.url;
          }
        }
        for (let item of this.params.details[0].purchases) {
          if (item && item.url) {
            delete item.url;
          }
        }
        this.params.status = status;

        this.params.sendAddress =
          this.params.area.join("") + this.params.tmpAddress;

        this.params.area = this.params.area.join("/");
        // delete this.params.tmpAddress;
        if (this.params.areaCode?.node) delete this.params.areaCode.node;
        if (this.$route.query.id) {
          await this.$http.updateRepairWithUser(this.params);
        } else {
          await this.$http.createRepairReq(this.params);
        }
        loading.close();
        this.$router.push({
          name: "RepairSuccess",
          query: { ...this.$route.query, submitStatus: this.params.status },
        });
        this.$message({
          message: "提交成功",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        this.params.area = this.params.area.split("/");
        loading.close();
        this.$message({
          message: "提交失败",
          type: "error",
        });
      }
    },

    copyAddress() {
      let str = `联系人：文石售后维修\n电话：13826127601\n地址：广州市南沙区东涌镇市鱼路202号一楼（4号楼）`;
      navigator.clipboard.writeText(str);
    },

    closeTips() {
      wx.miniProgram.navigateBack();
      if (!this.$route.query.t) {
        this.$router.push({ name: "SelfService" });
      }
    },

    async getEventNotif() {
      try {
        let res = await this.$http.getEventNotif({
          eventKey: "USER_ADD_REPAIR_REQ",
        });
        if (res.data.row) {
          this.tipsTitle = res.data.row.title;
          this.tipsMsg = res.data.row.message;
          this.showTips = true;
        } else {
          this.showTips = false;
        }
      } catch (error) {
        this.showTips = false;
        console.log(error);
      }
    },
  },
  mounted() {
    if (this.isMobile && !this.$route.query.forcePC) return;
    this.getEventNotif();
    if (this.$route.query.id && this.$route.query.t) {
      // 小程序编辑寄修单调用
      this.$local.set("afterSaleToken", this.$route.query.t);
      this.$cookie.set("afterSaleToken", this.$route.query.t);
      this.getDetails();
      this.$nextTick(() => {
        this.active = 3;
      });
    } else if (!this.$route.query.id && this.$route.query.t) {
      // 小程序创建寄修单调用
      this.$local.remove("afterSaleToken");
      this.$cookie.remove("afterSaleToken");
    } else if (this.$route.query.id && !this.$route.query.t) {
      // 网页编辑调用
      this.getDetails();
    }

    if (window.performance.navigation.type !== 1) {
      this.$local.remove("tips");
    }
  },
  created() {
    // 检测是否是移动设备，如果是则重定向到移动端页面
    if (this.isMobile && !this.$route.query.forcePC) {
      this.$router.replace({
        name: "RepairReqMobile",
        query: { ...this.$route.query },
      });
    }
  },
};
</script>
<style lang="scss">
.repairReq-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  /* overflow-y: auto; */
  > .repairReq-header {
    padding: 0 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .repairReq-header-win {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .repairReq-header-line {
        padding: 0 10px;
        color: $themeColor;
      }
      > p {
        margin-right: 20px;
      }
      .repairReq-header-copy {
        /* margin-left: 10px; */
      }
    }
    .repairReq-header-mobile {
      display: none;
    }
  }
  > .repairReq-main {
    flex: 1;
    padding: 40px 5%;
    background: #fff;
    .repairReq-steps {
      text-align: center;
      padding-bottom: 40px;
      border-bottom: 1px solid #eeeeee;
      .repairReq-steps-title {
        margin-bottom: 30px;
      }
    }
  }
}

@media (max-width: 700px) {
  .repairReq-pc-steps {
    > .el-step {
      .el-step__main {
        display: none;
      }
    }
  }
  .repairReq-header-win {
    display: none !important;
  }
  .repairReq-header-mobile {
    display: block !important;
  }
}
@media (max-width: 1075px) {
  .repairReq-header-win {
    display: none !important;
  }
  .repairReq-header-mobile {
    display: block !important;
  }
}
</style>
